module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-Black.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-Black.eot
// module id = 1884
// module chunks = 0